/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonStratCommentInfo,
    JsonStratCommentInfoFromJSON,
    JsonStratCommentInfoFromJSONTyped,
    JsonStratCommentInfoToJSON,
} from './JsonStratCommentInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonStratCommentInfo
 */
export interface ApiResultOfListOfJsonStratCommentInfo {
    /**
     * 
     * @type {Array<JsonStratCommentInfo>}
     * @memberof ApiResultOfListOfJsonStratCommentInfo
     */
    data?: Array<JsonStratCommentInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonStratCommentInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonStratCommentInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonStratCommentInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonStratCommentInfo
     */
    result?: ApiResultOfListOfJsonStratCommentInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonStratCommentInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonStratCommentInfoFromJSON(json: any): ApiResultOfListOfJsonStratCommentInfo {
    return ApiResultOfListOfJsonStratCommentInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonStratCommentInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonStratCommentInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonStratCommentInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonStratCommentInfoToJSON(value?: ApiResultOfListOfJsonStratCommentInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonStratCommentInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

